module.exports = __webpack_public_path__ + "img/c3.daf039a7.png";